import React from "react";
import TwitterIcon from "@material-ui/icons/Twitter";
import "./App.css";
import "./Sidebar.css";
import Sidebaro from "./Sidebaro.js";
import HomeIcon from "@material-ui/icons/Home";
import ExploreIcon from "@material-ui/icons/Explore";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import BookmarksIcon from "@material-ui/icons/Bookmarks";
import ListAltIcon from "@material-ui/icons/ListAlt";
import MoreIcon from "@material-ui/icons/More";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import {Button} from "@material-ui/core"
function Sidebar() {
  return (
    <div className="sidebar">
      <TwitterIcon className="aaaa" />
      <Sidebaro text="Home" icon={HomeIcon} className="abcd" />
      <Sidebaro text="Explore" icon={ExploreIcon} />
      <Sidebaro text="Notification" icon={NotificationsActiveIcon} />
      <Sidebaro text="Messsages" icon={MailOutlineIcon} />
      <Sidebaro text="Bookmarks" icon={BookmarksIcon} />
      <Sidebaro text="Lists" icon={ListAltIcon} />
      <Sidebaro text="More" icon={MoreIcon} />
      <Sidebaro text="Profile" icon={PermIdentityIcon} />
      <Button variant ="outlined" className="sidebar-tweet">Tweet</Button>
    </div>
  );
}

export default Sidebar;
